var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3023)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4133 11.99H11.6883V10.82C12.1583 10.82 12.5333 10.78 12.8133 10.7C13.1033 10.62 13.3333 10.49 13.5033 10.31C13.6733 10.12 13.8233 9.85 13.9533 9.5H15.0633V20H13.4133V11.99ZM19.4941 20.15C18.6841 20.15 18.0641 19.92 17.6341 19.46C17.2041 19 16.9891 18.35 16.9891 17.51V11.99C16.9891 11.15 17.2041 10.5 17.6341 10.04C18.0641 9.58 18.6841 9.35 19.4941 9.35C20.3041 9.35 20.9241 9.58 21.3541 10.04C21.7841 10.5 21.9991 11.15 21.9991 11.99V17.51C21.9991 18.35 21.7841 19 21.3541 19.46C20.9241 19.92 20.3041 20.15 19.4941 20.15ZM19.4941 18.65C20.0641 18.65 20.3491 18.305 20.3491 17.615V11.885C20.3491 11.195 20.0641 10.85 19.4941 10.85C18.9241 10.85 18.6391 11.195 18.6391 11.885V17.615C18.6391 18.305 18.9241 18.65 19.4941 18.65ZM25.5 20.15C24.69 20.15 24.07 19.92 23.64 19.46C23.21 19 22.995 18.35 22.995 17.51V11.99C22.995 11.15 23.21 10.5 23.64 10.04C24.07 9.58 24.69 9.35 25.5 9.35C26.31 9.35 26.93 9.58 27.36 10.04C27.79 10.5 28.005 11.15 28.005 11.99V17.51C28.005 18.35 27.79 19 27.36 19.46C26.93 19.92 26.31 20.15 25.5 20.15ZM25.5 18.65C26.07 18.65 26.355 18.305 26.355 17.615V11.885C26.355 11.195 26.07 10.85 25.5 10.85C24.93 10.85 24.645 11.195 24.645 11.885V17.615C24.645 18.305 24.93 18.65 25.5 18.65ZM31.5059 20.15C30.6959 20.15 30.0759 19.92 29.6459 19.46C29.2159 19 29.0009 18.35 29.0009 17.51V11.99C29.0009 11.15 29.2159 10.5 29.6459 10.04C30.0759 9.58 30.6959 9.35 31.5059 9.35C32.3159 9.35 32.9359 9.58 33.3659 10.04C33.7959 10.5 34.0109 11.15 34.0109 11.99V17.51C34.0109 18.35 33.7959 19 33.3659 19.46C32.9359 19.92 32.3159 20.15 31.5059 20.15ZM31.5059 18.65C32.0759 18.65 32.3609 18.305 32.3609 17.615V11.885C32.3609 11.195 32.0759 10.85 31.5059 10.85C30.9359 10.85 30.6509 11.195 30.6509 11.885V17.615C30.6509 18.305 30.9359 18.65 31.5059 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3023",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1000);
export default __webpack_public_path__ + "static/media/1000.1f07178bbb0e61fa40f86bd34656eb54.svg";
export { ForwardRef as ReactComponent };